import React, { useState } from 'react';
import { MapPinIcon, MailIcon, PhoneIcon, ClockIcon } from 'lucide-react';
export function ContactSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      (e.target as HTMLFormElement).reset();
      // Hide success message after 5 seconds
      setTimeout(() => {
        setIsSuccess(false);
      }, 5000);
    }, 1500);
  };
  return <section id="contact" className="py-[100px] px-8 bg-brand-black" data-id="element-50">
      <div className="max-w-[1200px] mx-auto" data-id="element-51">
        <p className="text-[0.75rem] tracking-[4px] uppercase text-brand-red mb-3 font-semibold" data-id="element-52">
          Get In Touch
        </p>
        <h2 className="text-[1.8rem] sm:text-[2.4rem] font-extrabold text-brand-text mb-4 leading-[1.2]" data-id="element-53">
          Contact <span className="text-brand-red" data-id="element-54">Us</span>
        </h2>
        <div className="w-[50px] h-[3px] bg-brand-red mb-12" data-id="element-55"></div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.5fr] gap-12 items-start" data-id="element-56">
          {/* Info Side */}
          <div className="flex flex-col gap-6" data-id="element-57">
            <div className="flex items-start gap-4 p-6 bg-brand-cardBg border border-brand-border border-l-[3px] border-l-brand-red transition-transform duration-300 hover:translate-x-1" data-id="element-58">
              <div className="w-[40px] h-[40px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-59">
                <MapPinIcon size={20} data-id="element-60" />
              </div>
              <div data-id="element-61">
                <h4 className="text-[0.75rem] tracking-[2px] uppercase text-brand-red mb-1.5 font-bold" data-id="element-62">
                  Address
                </h4>
                <p className="text-[0.9rem] text-[#cccccc] font-semibold block mb-0.5" data-id="element-63">
                  285 Grace Ave
                </p>
                <p className="text-[0.9rem] text-[#cccccc] font-semibold block mb-0.5" data-id="element-64">
                  Secaucus, NJ 07094
                </p>
                <p className="text-[0.9rem] text-[#cccccc] font-semibold block" data-id="element-65">
                  United States
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-6 bg-brand-cardBg border border-brand-border border-l-[3px] border-l-brand-red transition-transform duration-300 hover:translate-x-1" data-id="element-66">
              <div className="w-[40px] h-[40px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-67">
                <MailIcon size={20} data-id="element-68" />
              </div>
              <div data-id="element-69">
                <h4 className="text-[0.75rem] tracking-[2px] uppercase text-brand-red mb-1.5 font-bold" data-id="element-70">
                  Email
                </h4>
                <a href="mailto:INFO@DOGOSELL.COM" className="text-[0.9rem] text-[#cccccc] font-semibold hover:text-brand-text transition-colors block" data-id="element-71">
                  INFO@DOGOSELL.COM
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 p-6 bg-brand-cardBg border border-brand-border border-l-[3px] border-l-brand-red transition-transform duration-300 hover:translate-x-1" data-id="element-72">
              <div className="w-[40px] h-[40px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-73">
                <PhoneIcon size={20} data-id="element-74" />
              </div>
              <div data-id="element-75">
                <h4 className="text-[0.75rem] tracking-[2px] uppercase text-brand-red mb-1.5 font-bold" data-id="element-76">
                  Phone
                </h4>
                <a href="tel:+15512331570" className="text-[0.9rem] text-[#cccccc] font-semibold hover:text-brand-text transition-colors block" data-id="element-77">
                  +1 551-233-1570
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 p-6 bg-brand-cardBg border border-brand-border border-l-[3px] border-l-brand-red transition-transform duration-300 hover:translate-x-1" data-id="element-78">
              <div className="w-[40px] h-[40px] bg-brand-red flex items-center justify-center shrink-0 text-brand-text" data-id="element-79">
                <ClockIcon size={20} data-id="element-80" />
              </div>
              <div data-id="element-81">
                <h4 className="text-[0.75rem] tracking-[2px] uppercase text-brand-red mb-1.5 font-bold" data-id="element-82">
                  Business Hours
                </h4>
                <p className="text-[0.9rem] text-brand-muted block mb-0.5" data-id="element-83">
                  Mon – Fri: 9:00 AM – 6:00 PM
                </p>
                <p className="text-[0.9rem] text-brand-muted block" data-id="element-84">
                  Sat: 10:00 AM – 3:00 PM
                </p>
              </div>
            </div>
          </div>

          {/* Form Side */}
          <div className="bg-brand-cardBg border border-brand-border p-6 sm:p-10" data-id="element-85">
            <p className="text-[1.1rem] font-bold uppercase tracking-[2px] text-brand-text mb-2" data-id="element-86">
              Send Us a Message
            </p>
            <p className="text-[0.85rem] text-brand-muted mb-8" data-id="element-87">
              Fill out the form below and we'll get back to you shortly.
            </p>

            <form onSubmit={handleSubmit} data-id="element-88">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5" data-id="element-89">
                <div className="flex flex-col gap-1.5" data-id="element-90">
                  <label htmlFor="name" className="text-[0.72rem] tracking-[2px] uppercase text-brand-red font-semibold" data-id="element-91">
                    Name
                  </label>
                  <input type="text" id="name" name="name" placeholder="Your full name" required className="bg-[#0d0d0d] border border-brand-border text-brand-text p-3 text-[0.9rem] outline-none transition-colors duration-300 focus:border-brand-red placeholder:text-[#444]" data-id="element-92" />
                </div>
                <div className="flex flex-col gap-1.5" data-id="element-93">
                  <label htmlFor="email" className="text-[0.72rem] tracking-[2px] uppercase text-brand-red font-semibold" data-id="element-94">
                    Email
                  </label>
                  <input type="email" id="email" name="email" placeholder="your@email.com" required className="bg-[#0d0d0d] border border-brand-border text-brand-text p-3 text-[0.9rem] outline-none transition-colors duration-300 focus:border-brand-red placeholder:text-[#444]" data-id="element-95" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5" data-id="element-96">
                <div className="flex flex-col gap-1.5" data-id="element-97">
                  <label htmlFor="phone" className="text-[0.72rem] tracking-[2px] uppercase text-brand-red font-semibold" data-id="element-98">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" placeholder="+1 (000) 000-0000" className="bg-[#0d0d0d] border border-brand-border text-brand-text p-3 text-[0.9rem] outline-none transition-colors duration-300 focus:border-brand-red placeholder:text-[#444]" data-id="element-99" />
                </div>
                <div className="flex flex-col gap-1.5" data-id="element-100">
                  <label htmlFor="subject" className="text-[0.72rem] tracking-[2px] uppercase text-brand-red font-semibold" data-id="element-101">
                    Subject
                  </label>
                  <select id="subject" name="subject" className="bg-[#0d0d0d] border border-brand-border text-brand-text p-3 text-[0.9rem] outline-none transition-colors duration-300 focus:border-brand-red appearance-none" data-id="element-102">
                    <option value="" className="bg-[#111]" data-id="element-103">
                      Select a subject
                    </option>
                    <option value="general" className="bg-[#111]" data-id="element-104">
                      General Inquiry
                    </option>
                    <option value="support" className="bg-[#111]" data-id="element-105">
                      Customer Support
                    </option>
                    <option value="shipping" className="bg-[#111]" data-id="element-106">
                      Shipping & Delivery
                    </option>
                    <option value="partnership" className="bg-[#111]" data-id="element-107">
                      Partnership
                    </option>
                    <option value="other" className="bg-[#111]" data-id="element-108">
                      Other
                    </option>
                  </select>
                </div>
              </div>

              <div className="flex flex-col gap-1.5 mb-6" data-id="element-109">
                <label htmlFor="message" className="text-[0.72rem] tracking-[2px] uppercase text-brand-red font-semibold" data-id="element-110">
                  Message
                </label>
                <textarea id="message" name="message" placeholder="Write your message here..." required className="bg-[#0d0d0d] border border-brand-border text-brand-text p-3 text-[0.9rem] outline-none transition-colors duration-300 focus:border-brand-red placeholder:text-[#444] min-h-[120px] resize-y" data-id="element-111"></textarea>
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full py-3.5 bg-brand-red text-brand-text font-bold text-[0.9rem] tracking-[3px] uppercase cursor-pointer transition-all duration-300 hover:bg-brand-darkRed hover:-translate-y-0.5 clip-parallelogram-sm mt-2 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:translate-y-0 flex items-center justify-center gap-2" data-id="element-112">
                {isSubmitting ? 'Sending...' : <>
                    <span data-id="element-113">▶</span> Send Message
                  </>}
              </button>

              {isSuccess && <div className="bg-[#0a1a0a] border border-[#1a4a1a] text-[#4caf50] p-4 text-center text-[0.9rem] mt-4 tracking-[1px]" data-id="element-114">
                  ✅ &nbsp; Message sent successfully! We'll get back to you
                  soon.
                </div>}
            </form>
          </div>
        </div>
      </div>
    </section>;
}